// Feature Flag to toggle Shared-Element Page Transition (Listing -> Detail)
export const ENABLE_ARTWORK_SHARED_TRANSITION = true;

// Artwork availability statuses
export const UNAVAILABLE_ARTWORK_STATUSES = ["Sold", "Gift", "Reserved"] as const;
export const SOLD_ARTWORK_STATUSES = ["Sold", "Gift"] as const;

// List of 100 uniquely chosen artworks to be used only in the moving
// artworks grid of the movement page
export const THE_MOVEMENT_GRID_PHOTO_NAMES: Array<{
  photo_name: string;
  photo_width: number;
  photo_height: number;
}> = [
  {
    photo_name: "att269FBtVwaOwxnw",
    photo_width: 3734,
    photo_height: 2789,
  },
  {
    photo_name: "attckr4eblPbwgvCl",
    photo_width: 1962,
    photo_height: 1389,
  },
  {
    photo_name: "attRAxDWLLF4DRu76",
    photo_width: 1434,
    photo_height: 1062,
  },
  {
    photo_name: "attQ1zY8chpfIoops",
    photo_width: 2394,
    photo_height: 2395,
  },
  {
    photo_name: "att5QM8YxKTYbka8M",
    photo_width: 1092,
    photo_height: 915,
  },
  {
    photo_name: "attFbG2qpVxqBG8uH",
    photo_width: 11412,
    photo_height: 7630,
  },
  {
    photo_name: "attaWGzoQllEFcJDU",
    photo_width: 9180,
    photo_height: 10948,
  },
  {
    photo_name: "att4M7NFVFvnU2sAW",
    photo_width: 7200,
    photo_height: 4834,
  },
  {
    photo_name: "attMnSESKjgD6cNUR",
    photo_width: 3986,
    photo_height: 3918,
  },
  {
    photo_name: "attpk1d1kZXmJgQse",
    photo_width: 773,
    photo_height: 990,
  },
  {
    photo_name: "attdF94WyvAZIwp8s",
    photo_width: 5743,
    photo_height: 7122,
  },
  {
    photo_name: "attq7r34kE5cOxStR",
    photo_width: 6000,
    photo_height: 3341,
  },
  {
    photo_name: "attaxhbCpFZZkiu2g",
    photo_width: 4160,
    photo_height: 3120,
  },
  {
    photo_name: "att1DyodOW19Xb3lS",
    photo_width: 8933,
    photo_height: 11441,
  },
  {
    photo_name: "attgqmfRIlhS8bm03",
    photo_width: 5502,
    photo_height: 7635,
  },
  {
    photo_name: "attNkTaleE4Rlndb4",
    photo_width: 12628,
    photo_height: 7670,
  },
  {
    photo_name: "attc8y3R2tW9UQJ1D",
    photo_width: 4911,
    photo_height: 5587,
  },
  {
    photo_name: "attfDxluPazECTh7o",
    photo_width: 5400,
    photo_height: 4686,
  },
  {
    photo_name: "attib53glFRUVy4ze",
    photo_width: 2000,
    photo_height: 2180,
  },
  {
    photo_name: "att2D3eGQE9fIdCHR",
    photo_width: 5396,
    photo_height: 2952,
  },
  {
    photo_name: "attStPANactRWfFnH",
    photo_width: 1427,
    photo_height: 3595,
  },
  {
    photo_name: "att7fCEeYBekecH0c",
    photo_width: 1058,
    photo_height: 1016,
  },
  {
    photo_name: "att5pbCu38NIVpNvu",
    photo_width: 16739,
    photo_height: 13424,
  },
  {
    photo_name: "attmkZCSY2xCA7wPl",
    photo_width: 8411,
    photo_height: 5967,
  },
  {
    photo_name: "attqN214p7A7czWjU",
    photo_width: 4243,
    photo_height: 3077,
  },
  {
    photo_name: "attNSVT8TYwFu2PqJ",
    photo_width: 3375,
    photo_height: 3974,
  },
  {
    photo_name: "attn8aLH66Tvt340N",
    photo_width: 3375,
    photo_height: 4219,
  },
  {
    photo_name: "attDfrUvJHfd1nS1y",
    photo_width: 1080,
    photo_height: 832,
  },
  {
    photo_name: "att36eNi0feQyyOrx",
    photo_width: 2693,
    photo_height: 1537,
  },
  {
    photo_name: "att6ZQhtVzAARCUB5",
    photo_width: 2000,
    photo_height: 822,
  },
  {
    photo_name: "attNgXx4I2tyHHXNa",
    photo_width: 2188,
    photo_height: 2159,
  },
  {
    photo_name: "attp2iIgavtt0D0V2",
    photo_width: 1024,
    photo_height: 1536,
  },
  {
    photo_name: "attTmimni1TxZTTYe",
    photo_width: 6000,
    photo_height: 8117,
  },
  {
    photo_name: "attsYqag26u6VojtV",
    photo_width: 3000,
    photo_height: 4000,
  },
  {
    photo_name: "attxgIdHdiQ0zc8r6",
    photo_width: 692,
    photo_height: 982,
  },
  {
    photo_name: "attHftlTF6o9y2RSw",
    photo_width: 4198,
    photo_height: 5437,
  },
  {
    photo_name: "attCxp6ptMsXH9UJW",
    photo_width: 7320,
    photo_height: 10327,
  },
  {
    photo_name: "attcK6hHVuPuKDkY8",
    photo_width: 1194,
    photo_height: 622,
  },
  {
    photo_name: "attK33X1SVpNevkYt",
    photo_width: 3924,
    photo_height: 1952,
  },
  {
    photo_name: "attsE42UeCEmyetNf",
    photo_width: 13838,
    photo_height: 8754,
  },
  {
    photo_name: "attlghua9cCnu4nxO",
    photo_width: 6450,
    photo_height: 4652,
  },
  {
    photo_name: "attW2Efz7lZX1izpR",
    photo_width: 1048,
    photo_height: 1308,
  },
  {
    photo_name: "attwe9TlewHRCNyhA",
    photo_width: 535,
    photo_height: 867,
  },
  {
    photo_name: "attQH6KK570z70Se5",
    photo_width: 954,
    photo_height: 1600,
  },
  {
    photo_name: "attvnbeVkWH0dklRN",
    photo_width: 2081,
    photo_height: 2867,
  },
  {
    photo_name: "attVGneo7KXNkIgQU",
    photo_width: 2000,
    photo_height: 1333,
  },
  {
    photo_name: "attY7VCqfqiKR2lkT",
    photo_width: 4096,
    photo_height: 4096,
  },
  {
    photo_name: "attPoBSvmdALlOtGP",
    photo_width: 696,
    photo_height: 914,
  },
  {
    photo_name: "attK7b4oeaMenUZvJ",
    photo_width: 2974,
    photo_height: 3970,
  },
  {
    photo_name: "attSEyJVI4gIRedl4",
    photo_width: 11512,
    photo_height: 6526,
  },
  {
    photo_name: "attHmrDs8DX3gyTla",
    photo_width: 2970,
    photo_height: 2146,
  },
  {
    photo_name: "attxH0jCZOBtodnev",
    photo_width: 8790,
    photo_height: 8207,
  },
  {
    photo_name: "attW8uf8yI0Y4eozn",
    photo_width: 2206,
    photo_height: 1459,
  },
  {
    photo_name: "attdps04rURiNCI0N",
    photo_width: 5821,
    photo_height: 2331,
  },
  {
    photo_name: "attVozQVtiqqiE0ts",
    photo_width: 1310,
    photo_height: 810,
  },
  {
    photo_name: "attRdB0n9xYlqj7CK",
    photo_width: 1282,
    photo_height: 910,
  },
  {
    photo_name: "attUdHErnxhvT4zDt",
    photo_width: 4624,
    photo_height: 2604,
  },
  {
    photo_name: "attyxt7aNpFGqebFa",
    photo_width: 4032,
    photo_height: 3024,
  },
  {
    photo_name: "att29SNfYk9Ph9PFo",
    photo_width: 9413,
    photo_height: 6427,
  },
  {
    photo_name: "attHoalFdJy7y0oQm",
    photo_width: 2483,
    photo_height: 3534,
  },
  {
    photo_name: "attIcPbvPrNmMlxYk",
    photo_width: 5728,
    photo_height: 4912,
  },
  {
    photo_name: "attAG8w026B0ZJgsX",
    photo_width: 658,
    photo_height: 1346,
  },
  {
    photo_name: "attjBBf4UKowiQKYd",
    photo_width: 2608,
    photo_height: 2110,
  },
  {
    photo_name: "attMwepdiwrHnwk2A",
    photo_width: 3030,
    photo_height: 6212,
  },
  {
    photo_name: "attp0c8ncdWaf4gOk",
    photo_width: 3181,
    photo_height: 2155,
  },
  {
    photo_name: "attnEBfRChbIiiGrx",
    photo_width: 2470,
    photo_height: 2481,
  },
  {
    photo_name: "att0MGidonhzasIoL",
    photo_width: 4669,
    photo_height: 5566,
  },
  {
    photo_name: "att26tqeyFK5Epy9R",
    photo_width: 2700,
    photo_height: 3375,
  },
  {
    photo_name: "att3bOxIDOs1StLS4",
    photo_width: 4528,
    photo_height: 3419,
  },
  {
    photo_name: "attmjegokOVxlU53e",
    photo_width: 1475,
    photo_height: 2832,
  },
  {
    photo_name: "attjfP9Ox343OnOlY",
    photo_width: 2000,
    photo_height: 2667,
  },
  {
    photo_name: "attgJdkF70XOW1MhP",
    photo_width: 1768,
    photo_height: 1156,
  },
  {
    photo_name: "attS9ISBaaYol6aBw",
    photo_width: 1985,
    photo_height: 2862,
  },
  {
    photo_name: "attzptmxe9jMkp46m",
    photo_width: 2327,
    photo_height: 2371,
  },
  {
    photo_name: "attPggrr1mnA4zRVa",
    photo_width: 2241,
    photo_height: 2293,
  },
  {
    photo_name: "atttX1sZdfoHUydDa",
    photo_width: 3177,
    photo_height: 1811,
  },
  {
    photo_name: "attKjwTyWPdFuDfnE",
    photo_width: 1707,
    photo_height: 2560,
  },
  {
    photo_name: "attTLoHkQ0e7ozxrC",
    photo_width: 3875,
    photo_height: 1529,
  },
  {
    photo_name: "attKuE690tkW6EIOw",
    photo_width: 11469,
    photo_height: 7515,
  },
  {
    photo_name: "attxC2fkN6PPTKH9K",
    photo_width: 12628,
    photo_height: 9406,
  },
  {
    photo_name: "attpygzkhyL3v7JSS",
    photo_width: 2000,
    photo_height: 2000,
  },
  {
    photo_name: "attVAVY1U9tWG2ffs",
    photo_width: 2062,
    photo_height: 2433,
  },
  {
    photo_name: "attAemhhi6MPiCaMV",
    photo_width: 2006,
    photo_height: 1726,
  },
  {
    photo_name: "attk4BKFRoqzQOtVF",
    photo_width: 2142,
    photo_height: 1518,
  },
  {
    photo_name: "attwCkyCpKpOGiafy",
    photo_width: 1088,
    photo_height: 1564,
  },
  {
    photo_name: "attYPSu3HpfXCpqi1",
    photo_width: 3023,
    photo_height: 3524,
  },
  {
    photo_name: "attywpV7f4UrhKnzt",
    photo_width: 3709,
    photo_height: 1860,
  },
  {
    photo_name: "att069hYxt03o84Xo",
    photo_width: 5654,
    photo_height: 8382,
  },
  {
    photo_name: "attp60pyhFY49Jc1X",
    photo_width: 2700,
    photo_height: 1967,
  },
  {
    photo_name: "attqtVHX3VOea8l2B",
    photo_width: 4352,
    photo_height: 5894,
  },
  {
    photo_name: "attGgRXDmHp5GU0Cb",
    photo_width: 7631,
    photo_height: 5247,
  },
  {
    photo_name: "attk0WMSy4tQLMZ6e",
    photo_width: 3240,
    photo_height: 3251,
  },
  {
    photo_name: "atthO9B1TP5u1JezJ",
    photo_width: 1569,
    photo_height: 3797,
  },
  {
    photo_name: "attZV11tGDBm2C4Gi",
    photo_width: 1357,
    photo_height: 2363,
  },
  {
    photo_name: "attlCalb8YflBEsZA",
    photo_width: 7723,
    photo_height: 6710,
  },
  {
    photo_name: "attqLwuqjssL1vMPQ",
    photo_width: 8929,
    photo_height: 12141,
  },
  {
    photo_name: "attjUknlzL4efZvqc",
    photo_width: 3589,
    photo_height: 5268,
  },
  {
    photo_name: "attE3CRrNLxnHlnvw",
    photo_width: 3120,
    photo_height: 5238,
  },
  {
    photo_name: "att0cpV08GvMRLiuw",
    photo_width: 4730,
    photo_height: 3150,
  },
  {
    photo_name: "attsapg3iLY0VVYn8",
    photo_width: 2908,
    photo_height: 3692,
  },
];
